import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  play: {
    id: 'common.play',
    defaultMessage: 'Play',
  },
  pause: {
    id: 'common.pause',
    defaultMessage: 'Pause',
  },
  previous: {
    id: 'common.previous',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'common.next',
    defaultMessage: 'Next',
  },
  back: {
    id: 'common.back',
    defaultMessage: 'Back',
  },
  forward: {
    id: 'common.forward',
    defaultMessage: 'Forward',
  },
  close: {
    id: 'common.close',
    defaultMessage: 'Close',
  },
  expand: {
    id: 'aria-button-expand',
    defaultMessage: 'Expand',
  },
  condense: {
    id: 'aria-button-condense',
    defaultMessage: 'Condense',
  },
  select: {
    id: 'common.select',
    defaultMessage: 'Select {title}',
  },
  deselect: {
    id: 'common.deselect',
    defaultMessage: 'Deselect {title}',
  },
  selectTrack: {
    id: 'common.select-track',
    defaultMessage: 'Select track',
  },
  deselectTrack: {
    id: 'common.deselect-track',
    defaultMessage: 'Deselect track',
  },
  download: {
    id: 'download.button.text',
    defaultMessage: 'Download',
  },
  downloaded: {
    id: 'download.button.downloaded',
    defaultMessage: 'Downloaded',
  },
  downloading: {
    id: 'download.button.downloading',
    defaultMessage: 'Downloading',
  },
  removeDownload: {
    id: 'download.button.remove',
    defaultMessage: 'Remove from downloads',
  },
  view: {
    id: 'common.view.title',
    defaultMessage: 'View details {title}',
  },
  search: {
    id: 'common.search',
    defaultMessage: 'Search',
  },
  openMenu: {
    id: 'common.openMenu',
    defaultMessage: 'Open menu',
  },
  closeMenu: {
    id: 'common.closeMenu',
    defaultMessage: 'Close menu',
  },
  reorder: {
    id: 'common.reorder',
    defaultMessage: 'Reorder',
  },
  remove: {
    id: 'common.remove',
    defaultMessage: 'Remove',
  },
  addToPlaylist: {
    id: 'playlist.add-to-playlist-button.text',
    defaultMessage: 'Add to playlist',
  },
  removeFromPlaylist: {
    id: 'playlist.remove-from-playlist-button.text',
    defaultMessage: 'Remove from playlist',
  },
  saveToCollection: {
    id: 'collection.button.save',
    defaultMessage: 'Save to collection',
  },
  removeFromCollection: {
    id: 'collection.button.remove',
    defaultMessage: 'Remove from my collection',
  },
  loading: {
    id: 'common.loading',
    defaultMessage: 'Loading',
  },
  shareTrack: {
    id: 'common.share-track',
    defaultMessage: 'Share track',
  },
  shareRecording: {
    id: 'common.share-recording',
    defaultMessage: 'Share recording',
  },
});
